import { createContext } from 'react';
import { globalController } from './controllers';

export const globalContext = createContext<typeof globalController | null>(null);
export const GlobalProvider = ({ children = [] }: { children?: JSX.Element[] | JSX.Element }) => {
  return <globalContext.Provider value={globalController}>{children}</globalContext.Provider>;
};
